<template>
  <div class="welcome-container">
    <div class="welcome-header">
      <h2>欢迎使用投票后台管理系统</h2>
      <p class="welcome-subtitle">{{ greeting }}，{{ displayNameFromStore }}</p>
    </div>

    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card shadow="hover" class="stats-card stats-card-blue" @click.native="$router.push('/home/user')">
          <div class="stats-item">
            <div class="stats-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">系统用户</div>
              <div class="stats-value">{{ stats.users || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stats-card stats-card-green" @click.native="$router.push('/home/partner')">
          <div class="stats-item">
            <div class="stats-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">合伙人</div>
              <div class="stats-value">{{ stats.partners || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stats-card stats-card-orange" @click.native="$router.push('/home/proposal')">
          <div class="stats-item">
            <div class="stats-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">议案总数</div>
              <div class="stats-value">{{ stats.proposals || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stats-card stats-card-purple" @click.native="$router.push('/home/vote')">
          <div class="stats-item">
            <div class="stats-icon">
              <i class="el-icon-circle-check"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">投票任务</div>
              <div class="stats-value">{{ stats.votingTasks || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="quick-actions">
      <h3><i class="el-icon-s-promotion"></i> 快捷操作</h3>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="action-card" @click="$router.push('/home/user')">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="action-card" @click="$router.push('/home/partner')">
            <i class="el-icon-s-custom"></i>
            <span>合伙人管理</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="action-card" @click="$router.push('/home/proposal')">
            <i class="el-icon-document"></i>
            <span>议案管理</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="action-card" @click="$router.push('/home/vote')">
            <i class="el-icon-circle-check"></i>
            <span>投票任务</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row :gutter="20" class="info-section">
      <el-col :span="12">
        <div class="tips-section">
          <h3><i class="el-icon-warning-outline"></i> 使用提示</h3>
          <el-card class="tips-card">
            <ul>
              <li><i class="el-icon-check"></i> 点击左侧菜单可以快速切换不同功能模块</li>
              <li><i class="el-icon-check"></i> 用户管理模块可以管理系统用户信息</li>
              <li><i class="el-icon-check"></i> 合伙人需关联用户并设置层级和出资比例</li>
              <li><i class="el-icon-check"></i> 议案需先发布才能创建投票任务</li>
              <li><i class="el-icon-check"></i> 确保数据准确性，操作前请仔细核对</li>
            </ul>
          </el-card>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="workflow-section">
          <h3><i class="el-icon-connection"></i> 业务流程</h3>
          <el-card class="workflow-card">
            <div class="workflow-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <div class="step-title">创建用户</div>
                <div class="step-desc">在用户管理中新增系统用户</div>
              </div>
            </div>
            <div class="workflow-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <div class="step-title">设置合伙人</div>
                <div class="step-desc">关联用户并配置层级和投资比例</div>
              </div>
            </div>
            <div class="workflow-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <div class="step-title">创建议案</div>
                <div class="step-desc">编写议案内容并发布</div>
              </div>
            </div>
            <div class="workflow-step">
              <div class="step-number">4</div>
              <div class="step-content">
                <div class="step-title">发起投票</div>
                <div class="step-desc">关联议案并选择参与合伙人</div>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUserList } from '@/api/systemUser'
import { getPartnerList } from '@/api/partner'
import { getProposalList } from '@/api/proposal'
import { getVoteTaskList } from '@/api/voteTask'

export default {
  name: 'Welcome',
  data () {
    return {
      stats: {
        users: 0,
        partners: 0,
        votingTasks: 0,
        proposals: 0
      },
      greeting: ''
    }
  },
  computed: {
    displayNameFromStore () {
      return this.$store.getters.displayName
    }
  },
  created () {
    this.updateGreeting()
    this.fetchStats()
  },
  methods: {
    updateGreeting () {
      const hour = new Date().getHours()
      if (hour < 6) {
        this.greeting = '凌晨好'
      } else if (hour < 9) {
        this.greeting = '早上好'
      } else if (hour < 12) {
        this.greeting = '上午好'
      } else if (hour < 14) {
        this.greeting = '中午好'
      } else if (hour < 18) {
        this.greeting = '下午好'
      } else if (hour < 22) {
        this.greeting = '晚上好'
      } else {
        this.greeting = '深夜好'
      }
    },
    async fetchStats () {
      try {
        const pageSize = 1
        const commonParams = { pageNum: 1, pageSize }
        const voteTaskParams = { page: 1, pageSize }

        const [usersRes, partnersRes, proposalsRes, tasksRes] = await Promise.all([
          getUserList(commonParams),
          getPartnerList(commonParams),
          getProposalList(commonParams),
          getVoteTaskList(voteTaskParams)
        ])

        this.stats = {
          users: usersRes.data ? (usersRes.data.total || (usersRes.data.list ? usersRes.data.list.length : 0)) : 0,
          partners: partnersRes.data ? (partnersRes.data.total || (partnersRes.data.list ? partnersRes.data.list.length : 0)) : 0,
          proposals: proposalsRes.data ? (proposalsRes.data.total || (proposalsRes.data.list ? proposalsRes.data.list.length : 0)) : 0,
          votingTasks: tasksRes.data ? (tasksRes.data.total || (tasksRes.data.records ? tasksRes.data.records.length : 0)) : 0
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.welcome-container {
  height: 100%;
  overflow: auto;
}

.welcome-header {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.welcome-header h2 {
  font-size: 32px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 600;
}

.welcome-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
}

.stats-row {
  margin-bottom: 30px;
}

.stats-card {
  height: 130px;
  border-radius: 12px;
  transition: all 0.3s;
  cursor: pointer;
  overflow: hidden;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.stats-card-blue {
  background: linear-gradient(135deg, #667eea 0%, #5a67d8 100%);
}

.stats-card-green {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
}

.stats-card-orange {
  background: linear-gradient(135deg, #f6ad55 0%, #ed8936 100%);
}

.stats-card-purple {
  background: linear-gradient(135deg, #9f7aea 0%, #805ad5 100%);
}

.stats-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  height: 100%;
}

.stats-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
}

.stats-icon i {
  font-size: 36px;
  color: #fff;
}

.stats-info {
  text-align: left;
  flex: 1;
}

.stats-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 8px;
}

.stats-value {
  font-size: 32px;
  color: #fff;
  font-weight: bold;
}

.quick-actions {
  margin-bottom: 30px;
}

.quick-actions h3 {
  margin-bottom: 20px;
  color: #303133;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.quick-actions h3 i {
  color: #667eea;
}

.action-card {
  height: 120px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid #e2e8f0;
}

.action-card:hover {
  transform: translateY(-5px);
  border-color: #667eea;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.2);
}

.action-card i {
  font-size: 42px;
  color: #667eea;
}

.action-card span {
  font-size: 16px;
  color: #303133;
  font-weight: 500;
}

.info-section {
  margin-bottom: 30px;
}

.tips-section h3,
.workflow-section h3 {
  margin-bottom: 20px;
  color: #303133;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tips-section h3 i {
  color: #f6ad55;
}

.workflow-section h3 i {
  color: #48bb78;
}

.tips-card {
  background: linear-gradient(135deg, #fef5e7 0%, #fdebd0 100%);
  border-radius: 12px;
  border: none;
}

.tips-card ul {
  padding-left: 0;
  margin: 0;
  list-style: none;
}

.tips-card li {
  line-height: 2.2;
  color: #744210;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tips-card li i {
  color: #f6ad55;
  font-size: 16px;
}

.workflow-card {
  background: linear-gradient(135deg, #e6fffa 0%, #b2f5ea 100%);
  border-radius: 12px;
  border: none;
}

.workflow-step {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 0;
  border-bottom: 1px dashed rgba(56, 161, 105, 0.3);
}

.workflow-step:last-child {
  border-bottom: none;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-title {
  font-size: 16px;
  color: #22543d;
  font-weight: 600;
  margin-bottom: 4px;
}

.step-desc {
  font-size: 14px;
  color: #2f855a;
}
</style>
